import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Navbar } from '@/components/Navbar';
import { LoginPage } from '@/pages/LoginPage';
import { HomePage } from '@/pages/HomePage';
import { MovieDetailPage } from '@/pages/MovieDetailPage';
import { MyBorrowsPage } from '@/pages/MyBorrowsPage';
import { SearchPage } from '@/pages/SearchPage';
import { SurpriseMePage } from '@/pages/SurpriseMePage';
import { WatchlistPage } from '@/pages/WatchlistPage';
import { UserProfilePage } from '@/pages/UserProfilePage';
import { MasterAdminPage } from '@/pages/MasterAdminPage';
import { ManageMoviesPage } from '@/pages/ManageMoviesPage';
import { StorageManagerPage } from '@/pages/StorageManagerPage';
import { VideoPlayerPage } from '@/pages/VideoPlayerPage';
import { AdminDashboard } from '@/pages/AdminDashboard';
import { Toaster } from 'sonner';
import '@/App.css';

const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <>
      {user && user !== false && <Navbar />}
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/movie/:movieId"
          element={
            <ProtectedRoute>
              <MovieDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/watch/:movieId"
          element={
            <ProtectedRoute>
              <VideoPlayerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-borrows"
          element={
            <ProtectedRoute>
              <MyBorrowsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <SearchPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/surprise"
          element={
            <ProtectedRoute>
              <SurpriseMePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/watchlist"
          element={
            <ProtectedRoute>
              <WatchlistPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master-admin"
          element={
            <ProtectedRoute masterOnly>
              <MasterAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-movies"
          element={
            <ProtectedRoute adminOnly>
              <ManageMoviesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/storage"
          element={
            <ProtectedRoute adminOnly>
              <StorageManagerPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" theme="dark" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
